// extracted by mini-css-extract-plugin
module.exports = {"container":"PDFViewer_container__VrPt2","controllers":"PDFViewer_controllers__2p9Lq","controllerBtn":"PDFViewer_controllerBtn__18uHF"};